import Vue from 'vue';
import VueRouter from 'vue-router';
import fundationRoutes from './routes';
import Settings from '../components/pages/settings.vue';
import SinkHandler from '../components/pages/sinkHandler.vue';
import Users from '../components/usersManagement/user/index.vue';

/* Overridables routes, simply add them to app router to do it */
let overridablesRoutes = [
    {
        path: '/settings',
        name: 'settings',
        component: Settings
    },
    {
        path: '/users',
        name: 'user-list',
        component: Users
    },
    {
        path: '*',
        name: 'sinkHandler',
        component: SinkHandler
    }
];

export default class FundationVueRouter extends VueRouter{
    constructor (options={}) {
        // Add fundation routes
        let routes = options.routes || [];
        routes = fundationRoutes.concat(routes);
        for(let defaultRoute of overridablesRoutes){
            let overridedRoute = routes.find(route => route.name == defaultRoute.name);
            if(overridedRoute === undefined){
                routes.push(defaultRoute);
            }
        }
        options.routes = routes;

        // Default settings
        options.mode = 'hash';

        options.linkActiveClass = 'open active';
        options.scrollBehavior = function (/*to, from*/) {
            return { x: 0, y: 0 };
        };
        super(options);
        this.timeoutNavigation = null;
        this.addNavigationLoader();
        // console.log(this);
    }
    addNavigationLoader(){
        let defaultTemplate = '<div class="ns-loading-overlay"><div class="ring-container"><div class="lds-ring"><p>loading</p><div></div><div></div><div></div><div></div></div></div></div>';
        let el = document.createElement('div');
        // el.innerHTML = this.$store.getters.setNavigationLoadingTemplate || defaultTemplate;
        el.innerHTML = defaultTemplate;
        let child = el.childNodes[0];

        this.beforeHooks.push((to, from, next) => {
            if(to.path === from.path) return next();
            document.querySelector('body').appendChild(child);
            this.timeoutNavigation = setTimeout(() => {
                next();
            }, 50);
        });
        this.afterHooks.push(() => {
            clearTimeout(this.timeoutNavigation);
            //vue.nextTick()
            Vue.nextTick()
                .then(() => {
                    document.querySelector('body').removeChild(child);
                });
        });
    }
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/fundation-app-vuejs/src/router/index.js
// module id = null
// module chunks = 